import PropTypes from 'prop-types'
import React from 'react'

import FaqGut from 'components/FaqGut'
import SectionWrapper from 'components/SectionWrapper'
import { Text, H2 } from 'styles/components/typography'

const BNutritionQuestions = ({ data, isMobile }) => {
  return (
    <SectionWrapper isWideToDesktop={isMobile} isOverflowHidden={true}>
      <div className="row">
        <div className="col-12">
          <div className="biome-questions">
            {data.description ? (
              <Text
                className="text-center my-2 my-md-6 mx-2 mx-md-0"
                dangerouslySetInnerHTML={{ __html: data.description }}
              />
            ) : null}
            {data.title ? (
              <H2
                as="h3"
                className="text-center my-2 my-md-3"
                dangerouslySetInnerHTML={{ __html: data.title }}
              />
            ) : null}
            <FaqGut isMobile={isMobile} theme="gray" data={data.list} />
          </div>
        </div>
      </div>
    </SectionWrapper>
  )
}

BNutritionQuestions.propTypes = {
  data: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
}

BNutritionQuestions.defaultProps = {
  isMobile: false,
}

export default BNutritionQuestions
